export enum WeekdayIndex {
  'вс' = 0,
  'пн' = 1,
  'вт' = 2,
  'ср' = 3,
  'чт' = 4,
  'пт' = 5,
  'сб' = 6,
}
